export const toClassname = (name) => name.replace(/_/g, '-');
